<template>
  <div class="dash-stats">
    <div class="dash-stat dash-stat--sales">
      <div class="dash-stat__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 3v18h18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7 14l3.5-3.5 3 3L19 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15 7h4v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="dash-stat__body">
        <span class="dash-stat__label">کل فروش</span>
        <strong class="dash-stat__value">{{ get_currency(info.total_order) }}</strong>
      </div>
    </div>

    <div class="dash-stat dash-stat--today">
      <div class="dash-stat__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="5" width="18" height="16" rx="2.5" stroke="currentColor" stroke-width="1.8"/>
          <path d="M3 10h18" stroke="currentColor" stroke-width="1.8"/>
          <path d="M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <circle cx="12" cy="15.5" r="1.5" fill="currentColor"/>
        </svg>
      </div>
      <div class="dash-stat__body">
        <span class="dash-stat__label">فروش امروز</span>
        <strong class="dash-stat__value">{{ get_currency(info.today_sales) }}</strong>
      </div>
    </div>

    <div class="dash-stat dash-stat--sms">
      <div class="dash-stat__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6.5A2.5 2.5 0 016.5 4h11A2.5 2.5 0 0120 6.5v7a2.5 2.5 0 01-2.5 2.5H10l-4 3.5V16H6.5A2.5 2.5 0 014 13.5v-7z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
          <path d="M8 9h8M8 12h5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="dash-stat__body">
        <span class="dash-stat__label">موجودی پیامک</span>
        <strong class="dash-stat__value">{{ info.sms_credit && info.sms_credit.Data != null ? info.sms_credit.Data : '—' }}</strong>
      </div>
    </div>

    <div class="dash-stat dash-stat--products">
      <div class="dash-stat__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 8.5l8-4.5 8 4.5v7l-8 4.5-8-4.5v-7z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
          <path d="M4 8.5l8 4.5 8-4.5M12 13v7" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="dash-stat__body">
        <span class="dash-stat__label">کل کالاها</span>
        <strong class="dash-stat__value">{{ info.products_count }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetsDropdown',
  props: {
    info: Object,
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.dash-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 0;
}

.dash-stat {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 14px;
  background: var(--panel-surface, #fff);
  box-shadow: var(--panel-shadow);
  border: 1px solid var(--panel-border, rgba(128, 148, 174, 0.12));
  min-width: 0;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.4s ease, border-color 0.4s ease;
}

.dash-stat:active {
  transform: scale(0.98);
}

.dash-stat__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dash-stat__icon svg {
  width: 20px;
  height: 20px;
}

.dash-stat__body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dash-stat__label {
  font-size: 12px;
  color: var(--panel-muted, #8094ae);
  line-height: 1.35;
}

.dash-stat__value {
  font-size: 15px;
  font-weight: 700;
  color: var(--panel-text, #364a63);
  line-height: 1.35;
  word-break: break-word;
}

.dash-stat--sales .dash-stat__icon {
  background: rgba(17, 17, 17, 0.12);
  color: #111111;
}

.dash-stat--today .dash-stat__icon {
  background: rgba(9, 169, 152, 0.12);
  color: #09a998;
}

.dash-stat--sms .dash-stat__icon {
  background: rgba(246, 153, 63, 0.14);
  color: #e08a2a;
}

.dash-stat--products .dash-stat__icon {
  background: rgba(232, 83, 100, 0.12);
  color: #e85364;
}

@media (min-width: 768px) {
  .dash-stats {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  .dash-stat {
    padding: 16px;
    border-radius: 14px;
  }

  .dash-stat__icon {
    width: 44px;
    height: 44px;
  }

  .dash-stat__icon svg {
    width: 22px;
    height: 22px;
  }

  .dash-stat__label {
    font-size: 13px;
  }

  .dash-stat__value {
    font-size: 17px;
  }

  .dash-stat:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 28px -18px rgba(31, 43, 58, 0.45);
  }
}
</style>
